import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { SezioneEconomica } from 'src/app/common/models/sezioni/sezione-economica';
import { SpeseDiGiudizio } from 'src/app/common/models/sezioni/spese-giudizio';
import { TipoTipologica } from 'src/app/common/models/tipologiche/tipo-tipologica';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';

@Component({
  selector: 'app-spese-giudizio-form',
  templateUrl: './spese-giudizio-form.component.html',
  styleUrls: ['./spese-giudizio-form.component.css']
})
export class SpeseGiudizioFormComponent implements OnInit {

  @Input() sezioneEconomica: SezioneEconomica;
  @Input() fascicolo: FascicoloFull;
  descrizioniSpese: TipoTipologica[] = [];
  spesa: SpeseDiGiudizio;
  speseForm: FormGroup;
  spese: SpeseDiGiudizio[] = [];
  url: string;
  isModifica: boolean = false;
  constructor(private form: FormBuilder, private ops: OperationsService, private modalService: ModalNotifyService) { }

  ngOnInit() {
    this.ops.getTipologicaOptions('tipospesegiudizio').subscribe(res => {
      if(res){
        this.descrizioniSpese = res.tipologiche;
      }
    })
    this.url = this.fascicolo.praticaBase.tipoPratica.endpoint + '/fasc/' + this.fascicolo.tipoFascicolo.endpoint + '/sez/economici/' + this.sezioneEconomica.id + '/petitum/speseGiudizio';
    this.spesa = new SpeseDiGiudizio();
    this.spese = this.sezioneEconomica.petitum.speseGiudizio;
    this.speseForm = this.form.group({
      descrizioneSpesa: [this.spesa.descrizioneSpesa, Validators.required],
      valoreSpesa: [this.spesa.valoreSpesa, Validators.required]
    })
  }

  addRecord(descrizioneSpesa: string){
    let duplicato = false;
    this.descrizioniSpese.forEach(el => {
      if(el.label.toLowerCase() === descrizioneSpesa.toLowerCase())
        duplicato = true
    })
    if(descrizioneSpesa && !duplicato){
      this.ops.addTipologicaOption('tipospesegiudizio', {id: null, descrizione: descrizioneSpesa, label: descrizioneSpesa, rimosso: false}).subscribe(res => {
        if(res){
          this.descrizioniSpese.push(res.tipologiche[0]);
        }
      })
    }else{
      console.log('nominativo gia presente');
      this.modalService.messaggioCustom(descrizioneSpesa + " gia presente nell'elenco Descrizione spesa", 'Attenzione');
    }
  }

  addSpesaGiudizio(){
    if(!this.isModifica){
      this.ops.addSpesaGiudizio(this.spesa, this.url).subscribe(res => {
        if(res){
          this.spese = res.sezione.petitum.speseGiudizio;
        }
      })
    }else{
      this.ops.updateSpeseGiudizio(this.spesa, this.url).subscribe(res => {
        if(res){
          this.spese =res.sezione.petitum.speseGiudizio;
        }
      })
      this.isModifica = false;
    }
    this.spesa = new SpeseDiGiudizio();
  }

  modificaSpesa(spesa: SpeseDiGiudizio){
    if(spesa.id === this.spesa.id){
      this.closeModifica();
    }else{
      this.spesa = Object.assign({}, spesa);
      this.isModifica = true;
    }
  }

  deleteSpesa(spesa: SpeseDiGiudizio){
    this.spesa = new SpeseDiGiudizio();
    this.isModifica = false;
    this.ops.deleteSpesaGiudizio(spesa, this.url).subscribe(res => {
      if(res){
        this.spese = res.sezione.petitum.speseGiudizio;
      }
    })
  }

  totale(){
    if(this.spese && this.spese.length > 0){
      return this.spese.reduce((acc, el) => {
        return el.valoreSpesa + acc
      },0).toFixed(2)
    }else {
      return 0.00
    }

  }

  closeModifica(){
    this.isModifica = false;
    this.spesa = new SpeseDiGiudizio();
  }
}
